/**
 * @file   听琴水榭
 * @create macaiqi 2025/07/03
 * @update 
 */
import React, { useEffect, useState } from 'react';
import img from "../../assets/images/tqsx/bg.webp";
import talkshade from "../../assets/images/tqsx/talk.png";
import talkshade1 from "../../assets/images/tqsx/talk1.png";
import { queryArchivesList } from '../../service';
import ZhiFa from './zhifa';
import GQZY from './GQZY';
import Music from './Music';
import './index.scss'
const Talk1 = ({ setShow, setMusic, setMData, MData }) => {
    useEffect(() => {
        queryArchivesList({
            resource: "MusicPlay",
            pagination: {
                size: 0,
                page: 0
            }
        }).then(res => {
            setMData(res?.records)
        })
    }, [])
    return (
        <div className="shade animate__animated animate__fadeIn animate__fast">
            <i
                className="close"
                onClick={() => {
                    setShow('tqsx');
                }}></i>
            <img src={talkshade1} alt="" style={{ width: "38.375rem", height: "21rem" }} />
            <div className="talk1btns">
                {MData?.map((item, index) => {
                    return (
                        <div className="b" key={index} onClick={() => {
                            setMusic(item.id)
                            setShow("music")
                        }}>{item.title}</div>
                    )
                })}
            </div>

        </div>
    )
}
export default function TQSX({ setToPage }) {
    const [show, setShow] = useState();
    const [music, setMusic] = useState();
    const [MData, setMData] = useState([])

    return (
        <div className='common-page tqsx-page animate__animated animate__fadeIn animate__faster '>
            <div className="imgbox">
                <img src={img} alt="" className="bg  " style={{ width: "120rem" }} />
                <div
                    className="hot"
                    onClick={() => {
                        setShow("hot");
                    }}

                ></div>
                <div
                    className="talkbtn talk animate__animated animate__pulse animate__faster	 animate__infinite"
                    onClick={() => {
                        setShow("talk");
                    }}
                ></div>
                <div className="linkbtn" onClick={() => {
                    setShow('link');
                }}>
                </div>

                {show === "talk" && <div className="shade animate__animated animate__fadeIn animate__fast">
                    <i
                        className="close"
                        onClick={() => {
                            setShow('tqsx');
                        }}></i>
                    <img src={talkshade} alt="" />

                    <div className="btn b1" onClick={() => {
                        setShow("zhifa")
                    }}>学习古琴弹奏指法
                    </div>
                    <div className="btn b2" onClick={() => {
                        setShow("talk1");
                    }}>不如你先弹给我听听
                    </div>
                </div>}
                {show === "talk1" && <Talk1 setShow={setShow} setMusic={setMusic} setMData={setMData} MData={MData} />}
                {show === 'zhifa' && <ZhiFa setShow={setShow} />}
                {show === 'hot' && <GQZY setShow={setShow} />}
                {show === "music" && <Music setShow={setShow} id={music} MData={MData} />}

                {show === "link" && (
                    <div className="common-page">
                        <iframe src={window.GQYZLINK} title="古琴演奏地址" frameBorder={0} />
                        <div
                            className="iframeclose"
                            onClick={() => {
                                setShow()
                            }}></div>
                    </div>
                )}
            </div>
            <div
                className="back"
                onClick={() => {
                    setToPage();
                }}
            ></div>
        </div>
    )
}
